function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.533 22.648l2.052-1.815-2.6-2.041c.838-.652 1.494-1.516 1.966-2.594.473-1.078.71-2.347.71-3.808v-.699c0-1.532-.278-2.884-.833-4.055-.555-1.17-1.34-2.07-2.353-2.696C14.462 4.313 13.304 4 12 4c-1.303 0-2.462.313-3.475.94S6.728 6.465 6.173 7.636c-.555 1.171-.833 2.526-.833 4.066v.774c.007 1.503.29 2.834.849 3.99.558 1.157 1.346 2.047 2.363 2.67 1.017.623 2.173.934 3.47.934.408 0 .802-.032 1.181-.096l3.33 2.674zm-4.511-5.22c-1.103 0-1.948-.44-2.536-1.322-.587-.88-.88-2.12-.88-3.716v-.763c.007-1.626.304-2.86.891-3.7.587-.842 1.422-1.263 2.503-1.263 1.089 0 1.927.426 2.514 1.278.587.853.88 2.099.88 3.739v.762c-.006 1.626-.3 2.863-.88 3.712-.58.848-1.411 1.273-2.492 1.273z"
});

function SvgQuestionViewIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _ref);
}

export default SvgQuestionViewIcon;